<template>
  <b-row>
    <QuickAccessElement
      v-for="quickaccess in quickaccesses"
      :key="quickaccess.id"
    />
  </b-row>
</template>

<script>
import QuickAccessElement from '@/components/QuickAccess/QuickAccessElement'
import { mapGetters } from 'vuex'
export default {
  name: 'QuickAccess',
  components: { QuickAccessElement },
  computed: {
    ...mapGetters([
      'getStoredQuickAccess'
    ]),
    quickaccesses () {
      return this.getStoredQuickAccess
    }
  },
  mounted () {
    this.$store.dispatch('getQuickAccess')
  }
}
</script>

<style scoped>

</style>
